export const RESET_DURATION = 2 * 60 * 60 * 1000; // 2 hours
